import useAuthorization from '@alltrails/context/hooks/useAuthorization';
import { useGetTrailSurfaceTypesQuery } from '@alltrails/maps/redux/mapsApi';
import { useAppSelector } from '@/utils/redux';

/**
 * Surface-type data for the trail being viewed within /explore, fetched only while the surfaceType layer is applied.
 *
 * These query args must stay identical to the ones `useTrailConditionsSource`'s `useSurfaceTypes` passes, so the map
 * polyline, the legend, and the conditions sidebar all share a single RTK Query cache entry rather than each issuing
 * their own request.
 *
 * @returns Whether the layer is applied, plus the trail's surface-type segments and aggregation while it is
 */
const useExploreTrailSurfaceTypes = () => {
  const { hasPermission } = useAuthorization();
  const { isApplied, trailId } = useAppSelector(state => ({
    isApplied: state.map.dynamicStyleIds.includes('surfaceType'),
    trailId: state.explore.currentTrail?.id
  }));

  const { data } = useGetTrailSurfaceTypesQuery(
    { includeSegments: true, showHidden: hasPermission({ permission: 'trails:manage' }), trailId: trailId ?? -1 },
    { skip: !isApplied || trailId === undefined }
  );

  return {
    aggregation: isApplied ? data?.surfaceTypes.aggregation : undefined,
    isApplied,
    segments: isApplied ? data?.surfaceTypes.segments : undefined
  };
};

export default useExploreTrailSurfaceTypes;
